import { Fragment } from "react";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

//MUI
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));

const Comments = ({ comments }) => {
  const classes = useStyles();

  return (
    <List className={classes.root}>
      {comments.map((comment, index) => {
        const { body, createdAt, userImage, username } = comment;
        return (
          <Fragment key={createdAt}>
            <ListItem alignItems="flex-start">
              <ListItemAvatar>
                <Avatar src={userImage} alt="comment" />
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant="h5">
                    <Link
                      style={{ fontWeight: "700 !important",color:"#2942ce" }}
                      to={`/users/${username}`}
                    >
                      @{username}
                    </Link>
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Typography variant="body1" style={{ color: "#5b7083" }}>
                      {dayjs(createdAt).format("h:mma, MMMM, DD, YYYY")}
                    </Typography>
                    <Typography variant="p" style={{ color: "#0f1419",width:"100%" }}>
                      {body}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
            {index !== comments.length - 1 && (
              <Divider variant="inset" component="li" fullWidth />
            )}
          </Fragment>
        );
      })}
    </List>
  );
};

Comments.propTypes = {
  comments: PropTypes.array.isRequired,
};

export default Comments;
